import axios from 'axios';
import qs from 'qs';
import device from './device';
import { sign } from './sign';
import user from './user';
import { Message } from 'element-ui';
import router from '@/router';
import store from '@/store/index';
import { Loading } from 'element-ui';
/**
 * 组装公共参数
 * @param {String} params 接口单独请求参数
 */
let loadingInstance;
const buildParams = (params = {}) => {
  // 公共参数
  let commonParams = {
    appkey: process.env.VUE_APP_CONFIG_APP_KEY,
    channel_id: process.env.VUE_APP_CONFIG_APP_CHANNEL_ID,
    api_version: '1',
    timestamp: (Date.now() / 1000).toFixed(),
    ua: device.ua(),
    deviceid: device.deviceId(),
    client: device.browser(),
    nonce: Math.random()
      .toString(36)
      .substr(2, 15),
    /*
    marketing_code: '120525', //'120441', //TODO  120441单票，120463联票
    merchant_code: '120525', //'120441', //120441单票，120463联票
    product_code: '3109',*/
    place_code: process.env.VUE_APP_PLACE_CODE,
    marketing_name: '自营渠道',
  };
  let currentUser = user.getUser();
  if (currentUser != null) {
    const sessionId = currentUser.sessionId;
    if (sessionId) {
      commonParams['sessionid'] = sessionId;
    }
  }
  // 合并参数
  let buildParams = Object.assign(commonParams, params);
  // 去除无用的空参数
  Object.keys(buildParams).forEach((key) => {
    if (buildParams[key] === null || buildParams[key] === undefined) {
      delete buildParams[key];
    }
  });
  // 签名
  buildParams['sign'] = sign(
    buildParams,
    process.env.VUE_APP_BASE_API,
    process.env.VUE_APP_CONFIG_APP_SECRET,
  );
  return buildParams;
};

// 创建axios实例
const instance = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 1000 * 25,
});
// 设置post请求头
instance.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';
/**
 * 请求拦截器
 * 每次请求前，如果存在token则在请求头中携带token
 */
instance.interceptors.request.use(
  (config) => {
    loadingInstance = Loading.service({
      fullscreen: true,
      text: '加载中...',
    });
    let data = config.data;
    data && (config.data = qs.stringify(buildParams(data)));
    config.params = { method: data.method };
    return config;
  },
  (error) => Promise.reject(error),
);

// 响应拦截器
instance.interceptors.response.use(
  // 请求成功
  async (res) => {
    let data = (res && res.data) || {};
    loadingInstance.close();
    if (res.status === 200) {
      if (
        Object.prototype.hasOwnProperty.call(data, 'return_code') &&
        data.return_code === 0
      ) {
        return data.data;
      } else {
        if (data.return_code === -250003 || data.return_code === -112004) {
          try {
            /*await confirm('会话已过期，点击确定将跳转到登录页重新登录！');*/
            Message({
              showClose: true,
              message: '会话已失效，请重新登录',
              type: 'warning',
            });
            store.commit('setIsLogin', false);
            router.push({
              path: '/login',
            });
          } catch (e) {
            console.log(e);
          }
        }
        if (
          data.return_message &&
          (data.return_code !== -250003 || data.return_code !== -112004)
        ) {
          Message({
            showClose: true,
            message: data.return_message,
            type: 'warning',
          });
          return Promise.reject(new Error(data.return_message));
        }
        return Promise.reject(res);
      }
    }
    return res;
  },
  // 请求失败
  (error) => {
    return Promise.reject(error);
  },
);

export default instance;
